import {
    getTripDetailsInRealTime,
} from "../../helpers/backend_helper";

import {
    getTripList,
    loadingData,
    errorMessages,
} from "./reducer";

export const getAllTripsRealTimeList = () => async (dispatch) => {
    try {
        dispatch(loadingData(true));
        const response = await getTripDetailsInRealTime();
        dispatch(getTripList(response));
    } catch (error) {
        console.error("Error fetching trip list:", error);
        dispatch(errorMessages("Something went wrong while fetching trips."));
    } finally {
        dispatch(loadingData(false));
    }
};

